/**
 * A timestamped, content-free trace of the upload path (plan upload-and-terminal-latency 1.2). Off unless the page has
 * `window.__tbUploadTrace` (an array the e2e bench installs before load); then each event is pushed as
 * `{ src: 'client', t: <epoch µs>, k: <kind>, ...numbers }`. Numbers only: no name, path or content.
 */
type Sink = { push(e: Record<string, string | number>): unknown };

export function traceOn(): boolean {
  return Array.isArray((globalThis as { __tbUploadTrace?: unknown }).__tbUploadTrace);
}

export function trace(k: string, fields: Record<string, number> = {}) {
  const sink = (globalThis as { __tbUploadTrace?: Sink }).__tbUploadTrace;
  if (!sink) return;
  sink.push({ src: 'client', t: Math.round((performance.timeOrigin + performance.now()) * 1000), k, ...fields });
}
